import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  SubmenuDefinition,
  SubmenuCarmiProps,
  SubmenuStyleProperties,
} from '../types';
import { castFromInheritIfNeeded } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  [],
  (_, carmiData) => carmiData,
);

export const css = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  ['compData', 'compProps', 'styleProperties'],
  ({ compData, styleProperties }) => {
    const {
      itemHorizontalSpacing,
      itemVerticalSpacing,
      itemVerticalPadding,
      itemHorizontalPadding,
      subItemsVerticalSpacingBefore,
      subItemsVerticalSpacingBetween,
      subItemHorizontalPadding,
      subItemVerticalPadding,
      align = 'start',
      itemAlign,
      subItemAlign,
    } = styleProperties as SubmenuStyleProperties;

    const { direction, itemDirection, subItemDirection } = compData;

    return {
      '--itemHorizontalSpacing': `${itemHorizontalSpacing}px`,
      '--itemVerticalSpacing': `${itemVerticalSpacing}px`,
      '--itemVerticalPadding': `${itemVerticalPadding}px`,
      '--itemHorizontalPadding': `${itemHorizontalPadding}px`,
      '--direction': direction,
      '--itemDirection': itemDirection,
      '--subItemDirection': subItemDirection,
      '--subItemsVerticalSpacingBefore': `${subItemsVerticalSpacingBefore}px`,
      '--subItemsVerticalSpacingBetween': `${subItemsVerticalSpacingBetween}px`,
      '--subItemHorizontalPadding': `${subItemHorizontalPadding}px`,
      '--subItemVerticalPadding': `${subItemVerticalPadding}px`,
      '--itemAlign': castFromInheritIfNeeded(itemAlign, align),
      '--subItemAlign': castFromInheritIfNeeded(subItemAlign, align),
    };
  },
);

export default createComponentMapperModel({ props, css });
